import { render, staticRenderFns } from "./TourStepsTemplate.vue?vue&type=template&id=13b70776"
import script from "./TourStepsTemplate.vue?vue&type=script&lang=js"
export * from "./TourStepsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports